var $ = require('jQuery');

/**
 * Downloader Class
 *
 * Note: Since bulk download is a common action, this class is generic and loads the submission URL and METHOD from
 *  the button directly to aid re-use.
 *  For custom single-use Markers, this information can be defined directly in the class.
 */
module.exports = function(marker) {

    var parent = this;
    var marker = marker;

    // Get the Marker instance
    this.getMarker = function() {
        return marker;
    };

    // Handle Download button click.
    this.downloadClicked = function() {

        var form = $("#marker-action-download");

        parent.getMarker().addIdsToForm(form);

        if(parent.getMarker().idsExist()) {
            form.submit();
        } else {
            parent.getMarker().displayError();
        }
    };

    // jQuery Bindings
    $("#marker-action-download .marker-action-button").on("click", this.downloadClicked);
};
